import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Helpers} from "../helpers";

@Component({
  selector: 'dropdown-filter',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dropdown-filter.component.html',
  styleUrls: ['./dropdown-filter.component.scss']
})
export class DropdownFilterComponent implements OnInit, OnChanges {
  debounced_search: Function;

  constructor() {
    this.debounced_search = Helpers.debounce((val: string) => this.search(val));
  }

  @Output() change: EventEmitter<any> = new EventEmitter<any>();

  @Input() placeholder: string = "Select a value"

  @Input() value: any | undefined;

  @Input() values: any[] = []

  @Input() identifier: string = "value";

  @Input() label: string = "label";
  _value :any | undefined;
  _values: any[] = [];

  toggle: boolean = false;

  ngOnInit() {
    this._values = structuredClone(this.values);
  }

  setInitialValue(value:any){
    switch (typeof value){
      case "string":
        this._value = this.values.find(v=> v[this.identifier] == value)
        break
      case "object":
        this._value = this.value;
        break;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['values']){
      this.values = changes['values']?.currentValue ?? [];
      this._values = structuredClone(this.values);
    }
    if(changes['value']?.firstChange){
      this.setInitialValue(changes['value'].currentValue);
    }
  }

  search(value: string) {
    if (value.length > 0) {
      this._values = this.values.filter(v => v[this.label].toLowerCase().indexOf(value.toLowerCase()) != -1)
    } else {
      this._values = this.values;
    }
  }

  clear() {
    this.select(undefined);
  }

  select(value: any | undefined) {
    this._value = value;
    this.change.emit(this._value)
    this.trigger();
  }

  trigger() {
    this.toggle = !this.toggle;
  }

}
